var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 7.33329C7.6001 7.33329 7.33341 7.59989 7.33341 7.99996V10.6666C7.33341 11.0667 7.6001 11.3333 8.00008 11.3333C8.40006 11.3333 8.66675 11.0667 8.66675 10.6666V7.99996C8.66675 7.59989 8.40006 7.33329 8.00008 7.33329Z",
    fill: "#1E2132"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 5.33329C7.33341 4.93323 7.6001 4.66663 8.00008 4.66663C8.40006 4.66663 8.66675 4.93323 8.66675 5.33329C8.66675 5.73336 8.33341 5.99996 8.00008 5.99996C7.66675 5.99996 7.33341 5.73336 7.33341 5.33329Z",
    fill: "#1E2132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 0.666626C3.93343 0.666626 0.666748 3.93323 0.666748 7.99996C0.666748 12.0667 3.93343 15.3333 8.00008 15.3333C12.0667 15.3333 15.3334 12.0667 15.3334 7.99996C15.3334 3.93323 12.0667 0.666626 8.00008 0.666626ZM8.00008 14C4.66675 14 2.00008 11.3333 2.00008 7.99996C2.00008 4.66663 4.66675 1.99996 8.00008 1.99996C11.3334 1.99996 14.0001 4.66663 14.0001 7.99996C14.0001 11.3333 11.3334 14 8.00008 14Z",
    fill: "#1E2132"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.17c43ae1.svg";
export { ForwardRef as ReactComponent };